import { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { loadCoPeopleIndex } from '../functions';
import { useCompany } from '../../../providers';

const CustomisationContractorAutocomplete = ({
   setCustomisations,
   customisations,
   setSaved,
}) => {
   const { company } = useCompany();
   const [options, setOptions] = useState([]);
   const [inputValue, setInputValue] = useState('');

   useEffect(() => {
      if (company) {
         (async () => {
            const coPeople = await loadCoPeopleIndex(company.cid);
            setOptions(coPeople);
         })();
      }
   }, [company]);
   return (
      <Autocomplete
         options={options}
         getOptionLabel={(option) => `${option.email}`}
         filterOptions={(options, { inputValue }) => {
            if (inputValue.length < 3) {
               return [];
            }
            return options.filter(
               (option) =>
                  option.email.toLowerCase().includes(inputValue.toLowerCase()) ||
                  option.name.toLowerCase().includes(inputValue.toLowerCase()),
            );
         }}
         renderInput={(params) => (
            <TextField
               {...params}
               variant="outlined"
               margin="normal"
               required
               fullWidth
               id="email"
               label="Email"
               name="email"
               value={inputValue}
               onInput={(e) => {
                  setInputValue(e.target.value);
               }}
               //  error={nameError.status}
               //  helperText={nameError.text}
            />
         )}
         onChange={(event, newValue) => {
            setCustomisations({ ...customisations, contractorHostEmail: newValue });
            setSaved(false);
         }}
         noOptionsText={
            inputValue.length < 3
               ? `Start typing to find your details (${
                    3 - inputValue.length
                 } more characters)`
               : 'No options'
         }
         fullWidth
      />
   );
};
export default CustomisationContractorAutocomplete;
